module.exports = __webpack_public_path__ + "img/heizhima.d5e11f81.jpg";